module.exports = __webpack_public_path__ + "media/images/icon-twitter@2x-1fdb72a6ab80095946f47ed00b7e8a2e.png";